/**
 * Aurora Canvas 状态（独立 Zustand store）
 * 仅记录"当前画布"元数据 + 保存状态
 * 画布内部数据由 React Flow 管理，本 store 不重复持有
 */

import { create } from 'zustand'

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error'

interface CanvasState {
  canvasId: string | null
  canvasName: string
  saveStatus: SaveStatus
  lastSavedAt: number | null
  errorMessage: string | null
  setCanvas: (id: string, name: string) => void
  setName: (name: string) => void
  markSaving: () => void
  markSaved: () => void
  markError: (msg: string) => void
  reset: () => void
}

export const useCanvasStore = create<CanvasState>((set) => ({
  canvasId: null,
  canvasName: 'Untitled Canvas',
  saveStatus: 'idle',
  lastSavedAt: null,
  errorMessage: null,
  setCanvas: (id, name) =>
    set({
      canvasId: id,
      canvasName: name,
      saveStatus: 'idle',
      lastSavedAt: null,
      errorMessage: null,
    }),
  setName: (name) => set({ canvasName: name }),
  markSaving: () => set({ saveStatus: 'saving', errorMessage: null }),
  markSaved: () => set({ saveStatus: 'saved', lastSavedAt: Date.now(), errorMessage: null }),
  markError: (msg) => set({ saveStatus: 'error', errorMessage: msg }),
  reset: () =>
    set({
      canvasId: null,
      canvasName: 'Untitled Canvas',
      saveStatus: 'idle',
      lastSavedAt: null,
      errorMessage: null,
    }),
}))
